import { render } from "./Row.vue?vue&type=template&id=c90bf526&scoped=true"
import script from "./Row.vue?vue&type=script&lang=js"
export * from "./Row.vue?vue&type=script&lang=js"

import "./Row.vue?vue&type=style&index=0&id=c90bf526&lang=scss&scoped=true"

import exportComponent from "/home/knavarro/Proyectos/IGP/programas-investigacion/cts-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c90bf526"]])

export default __exports__